import React, { Fragment } from 'react';

import { Cards, CountryPicker, Chart } from './components';
import { fetchData ,fetchData0} from './api/';
import styles from './App.module.css';
import {BrowserRouter as Router,Switch,Route, Redirect} from 'react-router-dom';
import Sidebar1 from './SidebarComponents/Sidebar1.js'
import  Home from './home/Home.js'
import About from './about/About.js'


import image from './images/image.png';
import { Button } from '@material-ui/core';
//install bootstrap also by: npm i bootstrap
//import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
//import "../node_modules/bootstrap/dist/js/bootstrap.bundle"


//install toast by-- /*npm i react-toastify*/
import {ToastContainer,toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ImageSlider1 from './components/Slider/ImageSlider1';
import { SliderData1 } from './components/Slider/SliderData1';

class App extends React.Component {
  state = {
    data: {},
    data0: {},
    country: '',
    charttype:true,
    aboutPage: true,
  }

  async componentDidMount() {
    const data = await fetchData();
    const data0 = await fetchData0();


    this.setState({ data });
    this.setState({ data0 });

  }

  handleCountryChange = async (country) => {
    const data = await fetchData(country);

    this.setState({ data, country: country });
  }

  render() {
    const { data, data0,country } = this.state;

    /*
    return (
      <div className={styles.container}>
        <Cards data={data} />
        <CountryPicker handleCountryChange={this.handleCountryChange} />
        <Chart data={data} country={country} /> 
      </div>
    );
    */

    var changeChart=e=>{
      this.setState({charttype:!this.state.charttype})
    }
/*
    var changeAbout=e=>{
      this.setState({aboutPage:!this.state.aboutPage})
    }
    */

    const x=this.state.charttype
    const y=this.state.country

    var notify2=e=>{
        if(y){
          if(x){
            toast.success('PieChart data came....',{position: toast.POSITION.TOP_RIGHT, autoClose:2500})
          
          }
          else{
            toast.info('BarChart data came....',{position: toast.POSITION.TOP_RIGHT, autoClose:2500})
            
          }
        }
        else{
          alert("Select Any Country to show Country Data in Bar chart/Pie chart.....")
        }
    }
    


    return(
      <div>
        <Router>
          <Sidebar1/>
          <div className={styles.container}>
              <Switch className={styles.container}>
                <Route  exact path='/'  render={()=>
                  <Fragment>
                    <Home/>
                    <ImageSlider1 slides={SliderData1}/>
                  
                  </Fragment>
                
                }></Route>
                <Route exact path='/globaldata' render={()=>
                  <Fragment>
                    <img className={styles.image} src={image} alt="COVID-19"/>
                    <Cards data={data0} country="Global"/>
                  </Fragment>
                
                }></Route>
                <Route exact path='/countrydata' render={()=>
                  <Fragment>
                    <Cards data={data} country={country} />
                    <CountryPicker handleCountryChange={this.handleCountryChange} />
                    <Button className={styles.btn} onClick={()=>{changeChart();notify2();}} >{x?'Click Me to show in PieChart':'Click Me to show in BarChart'}</Button>
                    <Chart data={data} country={country} x={x}/>
                    <ToastContainer/>
                  </Fragment>
                }></Route>
                <Route exact path='/about' exact render={()=>
                  <Fragment>
                    <About/>
                  </Fragment>
                
                }></Route>
                <Redirect to='/'/>
              </Switch>
          </div>
          


        </Router>
      </div>
    )


  }
}

export default App;